import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function RivestimentiPiscine() {
  return (
    <SpecializationPage
      testid="rivestimenti-piscine-page"
      quoteService="Rivestimenti per piscine"
      index="/ 10"
      title="Rivestimenti Piscine"
      lines={["Rivestimenti", "per piscine."]}
      subtitle="L'innovativo rivestimento polimerico per piscine: una membrana continua, impermeabile ed elegante che dona nuova vita a vasche nuove ed esistenti."
      image={IMG.pool}
      accent="Piscine impermeabili, eleganti e durature."
      intro={[
        "Il rivestimento polimerico è un sistema di ultima generazione applicato a spruzzo o a rullo che crea una superficie continua, totalmente priva di fughe e giunzioni. Aderisce perfettamente a cemento, vetroresina e vecchi rivestimenti, adattandosi a qualsiasi forma.",
        "Il risultato è una vasca impermeabile, resistente al cloro, ai raggi UV e agli agenti chimici, con finiture e colori personalizzabili. Ideale sia per la realizzazione di nuove piscine sia per il ripristino di vasche ammalorate.",
      ]}
      specs={[
        { k: "Fughe", v: "Zero" },
        { k: "Resistenza cloro/UV", v: "Elevata" },
        { k: "Colori", v: "Personalizzabili" },
        { k: "Finitura", v: "Anche antiscivolo" },
        { k: "Supporti", v: "Cemento · VTR · rivestimenti" },
        { k: "Durata", v: "Lunga durata" },
      ]}
      benefits={[
        { t: "Superficie senza fughe", d: "Membrana continua che elimina i punti critici e le infiltrazioni tipiche del mosaico." },
        { t: "Estetica su misura", d: "Ampia gamma di colori e finiture per una piscina unica ed elegante." },
        { t: "Igiene e pulizia", d: "Superficie liscia e compatta, facile da pulire e resistente ai batteri." },
        { t: "Resistenza chimica", d: "Inattaccabile da cloro, sali e prodotti per il trattamento dell'acqua." },
        { t: "Ripristino veloce", d: "Recupera vasche ammalorate senza demolizioni invasive." },
        { t: "Massima aderenza", d: "Perfetta adesione su cemento, vetroresina e vecchi rivestimenti." },
      ]}
      applications={[
        "Piscine private residenziali",
        "Piscine pubbliche e condominiali",
        "Piscine a sfioro (infinity)",
        "Piscine a skimmer",
        "Vasche idromassaggio e spa",
        "Centri benessere e wellness",
        "Fontane e vasche ornamentali",
        "Biolaghi e piscine naturali",
        "Ripristino di piscine esistenti",
        "Bordi, scale e gradini",
        "Zone spiaggia e beach entry",
        "Solarium e docce esterne",
        "Vasche in cemento armato",
        "Vasche in vetroresina",
        "Skimmer, bocchette e canaline",
        "Vasche di compensazione",
      ]}
      faqs={[
        { q: "Posso ripristinare una piscina esistente senza demolirla?", a: "Sì. Il rivestimento polimerico aderisce perfettamente a cemento, vetroresina e vecchi rivestimenti, permettendo di recuperare vasche ammalorate senza demolizioni invasive." },
        { q: "Il rivestimento resiste al cloro e ai prodotti per l'acqua?", a: "Sì. È resistente al cloro, ai sali, ai raggi UV e ai comuni prodotti chimici per il trattamento dell'acqua, mantenendo colore e prestazioni nel tempo." },
        { q: "Ci sono fughe come nel mosaico o nelle piastrelle?", a: "No. Si tratta di una membrana continua, totalmente priva di fughe e giunzioni, che elimina i punti critici dove tipicamente si verificano infiltrazioni." },
        { q: "Posso personalizzare colore e finitura?", a: "Sì. Sono disponibili diversi colori e finiture, anche antiscivolo per bordi, scale e zone di passaggio, per una piscina esteticamente su misura." },
        { q: "Su quali tipi di vasca si può applicare?", a: "Su piscine in cemento armato, in vetroresina e con vecchi rivestimenti, sia a sfioro che a skimmer, oltre a spa, vasche idromassaggio, fontane e biolaghi." },
      ]}
    />
  );
}
